import type { ReactNode } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthProvider';
import { BrandLogo } from './BrandLogo';
import { useActionMutation } from '../feedback/useActionMutation';

export function AppShell({ children }: { children: ReactNode }) {
  const { profile } = useAuth();
  const isAdmin = profile?.role === 'admin';
  const home = isAdmin ? '/admin' : '/dashboard';
  return <div className="app-shell">
    <header className="topbar">
      <BrandLogo to={home} compactOnMobile />
      <nav aria-label="Main navigation">
        <NavLink to={home}>{isAdmin ? 'Dispatch' : 'Home'}</NavLink>
        {!isAdmin && <NavLink to="/orders/new">New order</NavLink>}
        {!isAdmin && <NavLink to="/orders">History</NavLink>}
        {!isAdmin && <NavLink to="/notifications">Notifications</NavLink>}
        {!isAdmin && <NavLink to="/profile">Profile</NavLink>}
        <SignOutButton />
      </nav>
    </header>
    <main className="page">{children}</main>
  </div>;
}

export function SignOutButton() {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const logout = useActionMutation('auth.logout', { mutationFn: signOut, onSuccess: () => { navigate('/'); } });
  return <button className="link-button" disabled={logout.isPending} onClick={() => logout.mutate()}>Sign out</button>;
}

export function PageHeader({ eyebrow, title, action }: { eyebrow?: string; title: string; action?: ReactNode }) {
  return <div className="page-header"><div>{eyebrow && <p className="eyebrow">{eyebrow}</p>}<h1>{title}</h1></div>{action}</div>;
}
